export default __webpack_public_path__ + "static/media/BinanceChain.df456d4b.svg";